import { Helmet } from 'react-helmet-async'; // ★これと
import styled from 'styled-components';
const MainBackColorGradient = styled.div`
background: linear-gradient(
  to bottom, 
  rgba(155, 0, 63, 1) 0%,   /* 上：赤（不透明） */
  rgba(255, 69, 0, 0.7) 50%, /* 中間：orangered（半透明） */
  rgba(255, 69, 0, 0) 100%   /* 下：orangered（完全透明） */
);
`;
const CourceHighSchool = () => {

    return (
        <MainBackColorGradient>
            <Helmet>
                <title>TOSAYOBI高等学院 | 高知の通信制高校</title> {/* ←ここに希望するタイトルを設定 */}
                <meta name="description" content="TOSAYOBI高等学院の公式ウェブサイトです。高知で通信制高校をお探しの方へ。" />
                {/* 必要であれば、OGPタグなどもここに追加できます */}
                <meta property="og:title" content="TOSAYOBI高等学院" />
                <meta property="og:description" content="高知県で大学受験対策もできる通信制高校をお探しならTOSAYOBI高等学院。土佐塾予備校のノウハウで、一人ひとりに寄り添い高卒資格と志望大学合格をサポートします。" />
                <meta property="og:keywords" content="高知,予備校,入試,通信制" />
                {/* <meta property="og:image" content="ここにOGP画像のURL" /> */}
            </Helmet>
            <div>
                <h2 className='text-white p-5 pt-10 mt-40 text-center'>
                    <p className='text-white text-5xl md:text-6xl font-bold pl-4 py-3'>選べる３つの進学コース</p>
                </h2>
            </div>

            {/* コースの詳細 */}
            <section className="text-gray-600 body-font">
                <div className="container px-5 py-10 mx-auto flex flex-wrap">
                    <div className="flex flex-wrap -m-4">
                        <div className="p-4 lg:w-1/3 md:w-full">
                            <div className="flex bg-white border-2 rounded-lg border-gray-200 border-opacity-50 p-8 sm:flex-row flex-col">
                                <div className="flex-grow">
                                    <h2 className="text-gray-900 text-3xl title-font font-medium mb-3">進学コース(週5日)</h2>
                                    <p className="leading-relaxed text-lg text-left">現在の学力に合わせた学習計画で基礎学力をしっかり身につけ、大学受験や就職など希望する進路をサポートします。</p>
                                    <p className="pt-4 leading-relaxed text-lg font-bold">こんな方におススメ!</p>
                                    <div className='inline-grid'>
                                        <p className="leading-relaxed text-lg text-start">・毎日通学に通いたい</p>
                                        <p className="leading-relaxed text-lg text-start">・志望校に合格したい</p>
                                    </div>

                                    <p className="text-gray-900 pt-5 leading-relaxed text-xl md:text-2xl">年間学納金 660,000円<span className='text-sm'>(税込)</span></p>
                                    <p className="text-gray-900 pt-0 leading-relaxed text-lg">（月額料金 55,000(授業料 + その他・施設費) × 12か月）</p>
                                </div>
                            </div>
                        </div>
                        <div className="p-4 lg:w-1/3 md:w-full">
                            <div className="flex bg-white border-2 rounded-lg border-gray-200 border-opacity-50 p-8 sm:flex-row flex-col">
                                <div className="flex-grow">
                                    <h2 className="text-gray-900 text-3xl title-font font-medium mb-3">単位取得コース(週3日)</h2>
                                    <p className="leading-relaxed text-lg text-left">高等学校卒業を目標としたコースです。無理のない学習計画を立て自分のペースで学習していきます。</p>
                                    <p className="pt-4 leading-relaxed text-lg font-bold">こんな方におススメ!</p>
                                    <div className='inline-grid'>
                                        <p className="leading-relaxed text-lg text-start">・毎日通学するのが不安</p>
                                        <p className="leading-relaxed text-lg text-start">・自分のやりたいことに時間を取りたい</p>
                                    </div>

                                    <p className="text-gray-900 pt-5 leading-relaxed text-xl md:text-2xl">年間学納金 528,000円<span className='text-sm'>(税込)</span></p>
                                    <p className="text-gray-900 pt-0 leading-relaxed text-lg">（月額料金 44,000(授業料 + その他・施設費) × 12か月）</p>
                                </div>
                            </div>
                        </div>
                        <div className="p-4 lg:w-1/3 md:w-full">
                            <div className="flex bg-white border-2 rounded-lg border-gray-200 border-opacity-50 p-8 sm:flex-row flex-col">
                                <div className="flex-grow">
                                    <h2 className="text-gray-900 text-3xl title-font font-medium mb-3">モバイルコース</h2>
                                    <p className="mt-0 leading-relaxed text-sm text-orange-600">※第一学院高等学校のみの在籍となります。</p>
                                    <p className="pt-5 leading-relaxed text-lg">オンラインで好きな時間・ 場所で学べるコースです。</p>
                                    <p className="pt-4 leading-relaxed text-lg font-bold">こんな方におススメ!</p>
                                    <div className='inline-grid'>
                                        <p className="leading-relaxed text-lg text-start">・通学が難しい</p>
                                        <p className="leading-relaxed text-lg text-start">・自分のペースで学習したい</p>
                                    </div>

                                    <p className="mt-5"><a href="https://www.daiichigakuin.ed.jp/course/mobilehighschool/" className='bg-orange-600 border-2 rounded-lg text-lg text-white p-3'>詳細はこちら</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="p-4 w-full">
                            <div className="flex bg-white border-2 rounded-lg border-gray-200 border-opacity-50 p-8 sm:flex-row flex-col">
                                <div className="flex-grow">
                                    <p className="text-gray-900 mt-0 leading-relaxed text-xl md:text-3xl">入学金 30,000円<span className='text-sm md:text-lg'>(税込)</span></p>
                                    <p className="text-gray-900 mt-0 leading-relaxed text-lg text-left">年間費用は一括または二分割でお支払いいただきます。特別活動などで実費が必要な場合は、別途ご請求いたします。</p>
                                    <p className="text-gray-900 mt-0 leading-relaxed text-lg text-left">第一学院高等学校には別途授業料・その他費用が必要となります。</p>
                                    <p className="text-gray-900 mt-0 leading-relaxed text-lg text-left">（ただし、第一学院高等学校の授業料は高等学校等就学支援金制度の対象です。)</p>
                                </div>
                            </div>
                        </div>
                        {/* お問い合わせフォーム */}
                        <div className='p-4 w-full mt-10 text-center'>
                            <a href='/mail/supportSchoolMail.php' className='bg-red-700 border-2 rounded-lg text-xl md:text-3xl text-white p-3'>
                                <span className="material-symbols-outlined pr-2 text2xl">mail</span>
                                お問い合わせはこちら
                            </a>
                        </div>
                    </div>

                </div>
            </section>

        </MainBackColorGradient >
    );
};
export default CourceHighSchool;
